
import React, { Component } from 'react';
import { initiateForgotPassword } from '../utils/forgot-password';

class ForgotPassword extends Component {
  handleUsername = (e) => {
    const value = e.target.value;
    this.props.onUsernameChange?.(value);
  };

  handleSendOtp = async (e) => {
    e.preventDefault();
    const { username, onChangeView } = this.props;

    if (!username || !username.trim()) {
      alert('Please enter your username (email).');
      return;
    }

    try {
      await initiateForgotPassword(username);
      // Navigate to the "SetNewPassword" view where you already pass username from parent
      onChangeView?.('SetNewPassword');
    } catch (err) {
      console.error('Failed to initiate forgot password:', err);
      alert('Could not send OTP. Please check the username and try again.');
    }
  };

  render() {
    const { currentView, username } = this.props;

    return (
      <div className='swagger-ui'>
        <div className='forgot-form'>
          <div className='forgot-heading'>
            <span className='forgot-form-heading'>Forgot Password</span>
          </div>
          {currentView === 'ForgotPassword' && (
            <form className='forgot-passwod-form'>
              <label className='forgot-password-label' htmlFor='fp-username'>
                Enter Username
              </label>
              <input
                id='fp-username'
                type='text'
                className='forgot-username'
                required
                value={username || ''}       // controlled by parent
                onChange={this.handleUsername}
                placeholder='Enter your username (email)'
              />
              <button
                type='button'
                onClick={this.handleSendOtp}
                disabled={!username || !username.trim()}
              >
                Send Otp
              </button>
            </form>
          )}
        </div>
      </div>
    );
  }
}

export default ForgotPassword;